import React from 'react';
export const ErrorDetailsModal = ({
  dataset,
  onClose,
  onBackToDataset
}) => {
  // Sample error data
  const errors = [{
    id: 1,
    type: 'Data Validation',
    message: 'Null value for room type',
    timestamp: '2023-05-15 09:12 AM'
  }, {
    id: 2,
    type: 'Data Validation',
    message: '0 value for room rate',
    timestamp: '2023-05-15 09:14 AM'
  }];
  return <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" data-id="element-561">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-md" data-id="element-562">
        <div className="flex justify-between items-center border-b border-gray-200 px-6 py-4" data-id="element-563">
          <h3 className="text-lg font-medium text-gray-900" data-id="element-564">
            Errors: {dataset.name}
          </h3>
          <button className="text-gray-400 hover:text-gray-500" onClick={onClose} data-id="element-565">
            <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-566">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" data-id="element-567" />
            </svg>
          </button>
        </div>
        <div className="p-6" data-id="element-568">
          <button className="flex items-center text-blue-600 hover:text-blue-800 mb-4" onClick={onBackToDataset} data-id="element-569">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-1" viewBox="0 0 20 20" fill="currentColor" data-id="element-570">
              <path fillRule="evenodd" d="M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z" clipRule="evenodd" data-id="element-571" />
            </svg>
            Back to Dataset
          </button>
          <div className="flex items-center mb-4" data-id="element-572">
            <div className="h-8 w-8 rounded-full bg-red-100 flex items-center justify-center mr-3" data-id="element-573">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-red-500" viewBox="0 0 20 20" fill="currentColor" data-id="element-574">
                <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" data-id="element-575" />
              </svg>
            </div>
            <h4 className="font-medium text-gray-900" data-id="element-576">Error Details</h4>
          </div>
          <p className="text-sm text-gray-600 mb-4" data-id="element-577">
            {dataset.errorCount} errors found in this dataset.
          </p>
          <div className="space-y-4 mb-6" data-id="element-578">
            {errors.map(error => <div key={error.id} className="border border-red-200 rounded-md p-4" data-id="element-579">
                <div className="flex items-start" data-id="element-580">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-red-500 mr-2 mt-0.5" viewBox="0 0 20 20" fill="currentColor" data-id="element-581">
                    <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" data-id="element-582" />
                  </svg>
                  <div className="flex-1" data-id="element-583">
                    <div className="flex justify-between" data-id="element-584">
                      <h5 className="font-medium text-gray-900" data-id="element-585">
                        {error.type}
                      </h5>
                      <span className="text-xs text-gray-500" data-id="element-586">
                        {error.timestamp}
                      </span>
                    </div>
                    <p className="text-sm text-red-600 mt-1" data-id="element-587">{error.message}</p>
                  </div>
                </div>
              </div>)}
          </div>
          <div className="flex justify-end gap-3" data-id="element-588">
            <button className="px-4 py-2 border border-gray-300 text-gray-700 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2" data-id="element-589">
              Export Error Log
            </button>
            <button className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2" data-id="element-590">
              Fix Errors
            </button>
          </div>
        </div>
      </div>
    </div>;
};